export const GET_MESSAGES = "GET_MESSAGES";
export const GOT_MESSAGES = "GOT_MESSAGES";
export const GOT_MESSAGES_ERROR = "GOT_MESSAGES_ERROR";

export const SEND_TEXT_MESSAGE = "SEND_TEXT_MESSAGE";
export const SEND_OPERATION_MESSAGE = "SEND_OPERATION_MESSAGE";
export const SEND_STICKER_MESSAGE = "SEND_STICKER_MESSAGE";


export const START_WATCH_MESSAGES = "START_WATCH_MESSAGES";
export const STOP_WATCH_MESSAGES = "STOP_WATCH_MESSAGES";
